<template>
  <div class="user-container">
    <van-cell-group inset>
      <van-cell size="large" class="info">
        <template #title>
          <van-image round fit="fill"
            :src="$parent.userInfo.headUrl ? jumpURL + $parent.userInfo.headUrl : require('../../assets/avatar.jpg')"></van-image>
          <div class="info">
            <b>{{ $parent.userInfo.displayName }}</b>
            <van-tag round size="medium" color="var(--mainColor)">
              {{ ['学生', '家长', '教职工', '管理员'][$parent.userInfo.userDict] }}</van-tag>
          </div>
        </template>
      </van-cell>
      <van-cell size="large" is-link title="个人设置" icon="setting-o"></van-cell>
      <van-cell size="large" is-link title="消息通知" icon="chat-o"></van-cell>
      <van-cell size="large" is-link title="退出登录" icon="close" @click.native.prevent="logout"></van-cell>
    </van-cell-group>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
export default {
  name: 'User',
  data() {
    return {
      jumpURL
    }
  },
  methods: {
    async logout() {
      localStorage.clear()
      window.location.href = jumpURL + '/mobile/'
    }
  }
}
</script>

<style lang="scss" scoped>
.user-container {
  padding: 20px 0;
  height: 100%;
  position: relative;

  .van-cell {

    &.info {
      .van-cell__title {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        height: 10vh;

        .van-image {
          height: 100%;
          aspect-ratio: 1;
        }

        .info {
          height: 80%;
          width: 50vw;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;

          b {
            font-size: 20px;
            color: #525252;
          }

          .van-tag {
            width: fit-content;
          }
        }
      }
    }
  }

  .van-button {
    margin-top: 30px;
  }
}
</style>